import { Button, Dialog, DialogContent, Typography, useMediaQuery, useTheme } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";

const SuccessDialog = (props) => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("md"));

  const { showSuccessDialog, onSuccessClick, successMsg } = props;
  return (
    <Dialog open={showSuccessDialog} className="info-dialog">
      <DialogContent sx={{ padding: "40px" }}>
        <Box mb={4}>
          <Typography
            variant="h2LatoBold"
            sx={{ color: theme.palette.common.textGrey2, fontFamily: "Lato-Regular" }}
          >
            {successMsg || "Your changes have been saved."}
          </Typography>
        </Box>
        <Box mb={2}>
          <Button
            variant="large"
            onClick={onSuccessClick}
            sx={{ minWidth: matches ? "150px" : undefined }}
          >
            DONE
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default SuccessDialog;
